import React from 'react'

const MediaFeatures = () =>
  <div className="page feature">
    <h1>Media</h1>
  </div>

export default MediaFeatures
